"use client";

import Image from "next/image";
import { cn } from "@/lib/utils";
import type { PlatformId } from "@/types/platforms";

const YOUTUBE_BRANDING_MIN_PX = 24;

interface PlatformLogoProps {
  platform: PlatformId;
  size?: number;
  className?: string;
}

export function PlatformLogo({
  platform,
  size = 24,
  className,
}: PlatformLogoProps) {
  const effectiveSize =
    platform === "youtube" ? Math.max(size, YOUTUBE_BRANDING_MIN_PX) : size;
  const altLabel = platform === "youtube" ? "YouTube" : platform;

  return (
    <Image
      src={`/api/images/platform-logo/${platform}/`}
      alt={altLabel}
      width={effectiveSize}
      height={effectiveSize}
      unoptimized
      className={cn("shrink-0 object-contain", className)}
    />
  );
}
